var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricedOrdersNotifyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.313965,
    y: 0.191406,
    width: 62.6328,
    height: 62.6328,
    rx: 6,
    fill: "white",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2823 30.5559C46.2611 30.5559 45.4335 31.3836 45.4335 32.4049C45.4335 40.5089 38.8402 47.1022 30.7362 47.1022C22.6326 47.1022 16.0388 40.5088 16.0388 32.4049C16.0388 24.3013 22.6326 17.7075 30.7362 17.7075C31.7573 17.7075 32.5851 16.8799 32.5851 15.8587C32.5851 14.8374 31.7573 14.0098 30.7362 14.0098C20.5925 14.0098 12.3411 22.2612 12.3411 32.4049C12.3411 42.548 20.5925 50.7999 30.7362 50.7999C40.8793 50.7999 49.1312 42.548 49.1312 32.4049C49.1312 31.3837 48.3036 30.5559 47.2823 30.5559Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9533 20.2493C47.0514 19.3463 45.5869 19.3469 44.6839 20.2493L29.9694 34.9644L23.4294 28.4245C22.5264 27.5215 21.0625 27.5215 20.1595 28.4245C19.2564 29.3276 19.2564 30.7914 20.1595 31.6945L28.3341 39.8691C28.7853 40.3203 29.377 40.5465 29.9688 40.5465C30.5605 40.5465 31.1528 40.3209 31.604 39.8691L47.9533 23.5192C48.8563 22.6168 48.8563 21.1523 47.9533 20.2493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricedOrdersNotifyIcon);
export default __webpack_public_path__ + "static/media/priced_orders_notify_icon.c5ffe1b87bba1fc163dd946112a493e6.svg";
export { ForwardRef as ReactComponent };